var _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _polygon2, _path9, _path10, _path11, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "300px",
    height: "300px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,93C22.888,93,11,81.112,11,66.5v-29C11,22.888,22.888,11,37.5,11h29 C81.112,11,93,22.888,93,37.5v29C93,81.112,81.112,93,66.5,93H37.5z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M35.5,91C20.888,91,9,79.112,9,64.5v-29C9,20.888,20.888,9,35.5,9h29C79.112,9,91,20.888,91,35.5 v29C91,79.112,79.112,91,64.5,91H35.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#964b96",
    points: "43.05,15.5 84.5,56.95 84.5,43.162 56.838,15.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#883561",
    d: "M72.147,17.021l10.832,10.832C80.951,22.96,77.04,19.049,72.147,17.021z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#774696",
    d: "M64.5,15.5h-7.662L84.5,43.162V35.5c0-2.709-0.545-5.29-1.521-7.647L72.147,17.021 C69.79,16.045,67.209,15.5,64.5,15.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a659b3",
    d: "M35.5,15.5c-1.897,0-3.724,0.281-5.463,0.775l53.688,53.688c0.493-1.739,0.775-3.566,0.775-5.463 v-7.55L43.05,15.5H35.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d84178",
    d: "M21.346,21.371l57.283,57.283c2.383-2.379,4.152-5.361,5.096-8.691L30.037,16.275 C26.707,17.219,23.724,18.988,21.346,21.371z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4665c",
    d: "M16.264,30.077l53.658,53.658c3.334-0.938,6.322-2.702,8.706-5.082L21.346,21.371 C18.966,23.755,17.203,26.743,16.264,30.077z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef8630",
    d: "M15.5,35.5v7.601L56.899,84.5H64.5c1.882,0,3.696-0.278,5.423-0.764L16.264,30.077 C15.778,31.804,15.5,33.618,15.5,35.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f9b84f",
    points: "15.5,56.888 43.112,84.5 56.899,84.5 15.5,43.101"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe385",
    d: "M15.5,64.5c0,2.739,0.553,5.349,1.55,7.726L27.774,82.95c2.378,0.997,4.987,1.55,7.726,1.55h7.612 L15.5,56.888V64.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe797",
    d: "M27.774,82.95L17.05,72.226C19.076,77.058,22.942,80.924,27.774,82.95z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#40396e",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M64.5,84.5h-29c-11.046,0-20-8.954-20-20v-29 c0-11.046,8.954-20,20-20h29c11.046,0,20,8.954,20,20v29C84.5,75.546,75.546,84.5,64.5,84.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M60.838,26.517H39.162 c-7.045,0-12.645,5.6-12.645,12.645v21.677c0,7.045,5.6,12.645,12.645,12.645h21.677c7.045,0,12.645-5.6,12.645-12.645V39.162 C73.483,32.117,67.883,26.517,60.838,26.517z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.995,
    cy: 36,
    r: 1.999,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 11.497,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9a2d4a5a4324dd312c8bffb00bf10d40.svg";
export { ForwardRef as ReactComponent };